<template>
  <div class="">
    <v-avatar
      style="cursor: pointer"
      size="80"
      color="grey lighten-2"
      @click="$refs.fileInput.click()"
    >
      <img
        v-show="previewSrc"
        :src="previewSrc"
        style="object-fit: cover"
        alt="Avatar"
      >
    </v-avatar>
    <p
      v-show="errorMessage"
      class="red--text"
    >
      {{errorMessage}}
    </p>
    <input
      style="display: none"
      type="file"
      ref="fileInput"
      @change="onChangeAvatar"
      accept="image/png, image/jpeg"
    />
  </div>
</template>

<script>
export default {
  name: 'AvatarSelector',
  props: {
    value: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      errorMessage: '',
    };
  },
  computed: {
    previewSrc() {
      if (this.value) {
        return `data:${this.value}`;
      }
      if (this.url) {
        return this.url;
      }

      return null;
    },
  },
  methods: {
    onChangeAvatar(e) {
      if (!e.currentTarget.files[0]) {
        this.errorMessage = 'Файл не выбран';
        return;
      }
      if (!([
        'image/png',
        'image/jpeg',
      ]).includes(e.currentTarget.files[0].type)) {
        this.errorMessage = 'Не верный формат файла';
        return;
      }
      if (e.currentTarget.files[0].size > 2000000) {
        this.errorMessage = 'Файл больше 2MB';
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        this.$emit('input', reader.result.substr(5));
      };
      reader.readAsDataURL(e.currentTarget.files[0]);
      this.$refs.fileInput.value = null;
    },
  },
};
</script>

<style scoped>

</style>
